export default "__VITE_ASSET__7dc81245__"